import { useTranslation } from 'react-i18next';
import EmptyIcon from '@/shared/assets/empty-icon.svg?react';
import Close16Icon from '@/shared/assets/close-16-icon.svg?react';
import { ButtonSmall } from '@/shared/components';

type Props = {
  isPeriodApplied: boolean;
  onPeriodReset: () => void;
};

export const EmptyStateView = ({ isPeriodApplied, onPeriodReset }: Props) => {
  const { t } = useTranslation();

  const localPath = isPeriodApplied
    ? 'emptyStateViewWithPeriod'
    : 'emptyStateView';

  return (
    <div className="flex flex-1 min-h-[32rem] flex-col items-center justify-center gap-[2.4rem] px-[1.6rem] py-[4.8rem]">
      <div className="flex w-full max-w-[30.4rem] flex-col items-center gap-[1.2rem] text-center">
        <EmptyIcon className="size-[4.8rem] text-primary" />

        <h2 className="headline4 text-primary">
          {t(`historyPage.${localPath}.title`)}
        </h2>

        <p className="p5 text-secondary whitespace-pre-line">
          {t(`historyPage.${localPath}.description`)}
        </p>
      </div>

      {isPeriodApplied && (
        <ButtonSmall icon={Close16Icon} onClick={onPeriodReset}>
          {t(`historyPage.${localPath}.buttonText`)}
        </ButtonSmall>
      )}
    </div>
  );
};
